var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Platform403ErrorView"},[_c('PlatformErrorMessage',{attrs:{"title":"Brak dostępu","description":"Niestety ale nie masz uprawnień do tej części aplikacji"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }